import { useTranslation } from 'react-i18next';
import UPInput from 'components/input';
import {
  CONTRACTS__PLANNED_TIME,
  CONTRACTS__START_WORK,
  CONTRACTS__END_WORK,
  CONTRACTS__BREAK,
  CONTRACTS__NO_PLANNING_EXISTS,
} from 'translations/constants';
import { ReactComponent as PlannedTimeIcon } from '../../../assets/icons/PlannedTimeIcon.svg';
import {
  TimeColumnContainer,
  SubSectionTitle,
  ColumnTitleRow,
  TimeFieldsRow,
  TimeFieldWrapper,
  BreakTitle,
  EmptyStateText,
} from '../styles';

interface PlannedTimeColumnProps {
  hasPlanning: boolean;
  startWork: string | null;
  endWork: string | null;
  startBreak: string | null;
  endBreak: string | null;
}

const PlannedTimeColumn = (props: PlannedTimeColumnProps) => {
  const { hasPlanning, startWork, endWork, startBreak, endBreak } = props;
  const { t } = useTranslation();

  return (
    <TimeColumnContainer>
      <ColumnTitleRow>
        <PlannedTimeIcon fill="#303C42" />
        <SubSectionTitle>{t(CONTRACTS__PLANNED_TIME)}</SubSectionTitle>
      </ColumnTitleRow>
      {!hasPlanning ? (
        <EmptyStateText>{t(CONTRACTS__NO_PLANNING_EXISTS)}</EmptyStateText>
      ) : (
        <>
          <TimeFieldsRow>
            <TimeFieldWrapper>
              <UPInput
                value={startWork ?? ''}
                onChange={null}
                placeholder=""
                label={t(CONTRACTS__START_WORK)}
                disabled
                id="detail-panel-planned-start"
              />
            </TimeFieldWrapper>
            <TimeFieldWrapper>
              <UPInput
                value={endWork ?? ''}
                onChange={null}
                placeholder=""
                label={t(CONTRACTS__END_WORK)}
                disabled
                id="detail-panel-planned-end"
              />
            </TimeFieldWrapper>
          </TimeFieldsRow>
          {startBreak && (
            <>
              <BreakTitle>{`${t(CONTRACTS__BREAK)} 1`}</BreakTitle>
              <TimeFieldsRow>
                <TimeFieldWrapper>
                  <UPInput
                    value={startBreak}
                    onChange={null}
                    placeholder=""
                    label={t(CONTRACTS__START_WORK)}
                    disabled
                    id="detail-panel-planned-break-start"
                  />
                </TimeFieldWrapper>
                <TimeFieldWrapper>
                  <UPInput
                    value={endBreak ?? ''}
                    onChange={null}
                    placeholder=""
                    label={t(CONTRACTS__END_WORK)}
                    disabled
                    id="detail-panel-planned-break-end"
                  />
                </TimeFieldWrapper>
              </TimeFieldsRow>
            </>
          )}
        </>
      )}
    </TimeColumnContainer>
  );
};

export default PlannedTimeColumn;
